import React from 'react'
import {
  Button,
  Stack,
  TextField,
} from '@material-ui/core'
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import { DatePicker } from '@material-ui/lab'
import { useTranslation } from 'react-i18next'

const DateFilter = ({ range, values, setValues }) => {
  const { t } = useTranslation()

  let fromDate = new Date()
  let toDate = new Date()

  if (values && values.length === 2) {
    fromDate.setFullYear(values[0])
    toDate.setFullYear(values[1])
  } else {
    fromDate = range[0]
    toDate = range[1]
  }

  const rangeIsValid = ([minYear, maxYear]) => {
    return (
      minYear <= maxYear
      && minYear >= range[0].getFullYear()
      && maxYear <= range[1].getFullYear()
    )
  }

  const updateFrom = newDate => {
    if (Object.prototype.toString.call(newDate) === '[object Date]' && !isNaN(newDate)) {
      const newValues = [newDate.getFullYear(), toDate.getFullYear()]
      if (rangeIsValid(newValues)) setValues(newValues)
    }
  }
  const updateTo = newDate => {
    if (Object.prototype.toString.call(newDate) === '[object Date]' && !isNaN(newDate)) {
      const newValues = [fromDate.getFullYear(), newDate.getFullYear()]
      if (rangeIsValid(newValues)) setValues(newValues)
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack spacing={2}>
        <DatePicker
          views={["year"]}
          label={t("filters.fromYear")}
          value={fromDate}
          onChange={updateFrom}
          renderInput={props => <TextField {...props} />}
          minDate={range[0]}
          maxDate={toDate}
        />
        <DatePicker
          views={["year"]}
          label={t("filters.toYear")}
          value={toDate}
          onChange={updateTo}
          renderInput={props => <TextField {...props} />}
          minDate={fromDate}
          maxDate={range[1]}
        />
        <Button color="primary" onClick={() => setValues([])}>
          {t("filters.resetYear")}
        </Button>
      </Stack>
    </LocalizationProvider>
  )
}

export default DateFilter
